var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFclosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Technology/folder/closed"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.66663 33.3335H73.3333M6.66663 60.0002V20.0002C6.66663 16.3183 9.65139 13.3335 13.3333 13.3335H23.9052C25.6733 13.3335 27.369 14.0359 28.6192 15.2861L31.3807 18.0475C32.6309 19.2978 34.3266 20.0002 36.0947 20.0002H66.6666C70.3485 20.0002 73.3333 22.9849 73.3333 26.6668V60.0002C73.3333 63.6821 70.3485 66.6668 66.6666 66.6668H13.3333C9.6514 66.6668 6.66663 63.6821 6.66663 60.0002Z",
    stroke: "#C1C3C7",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFclosed);
export default __webpack_public_path__ + "static/media/fclosed.1bb3a2a81664e91174948449196a213b.svg";
export { ForwardRef as ReactComponent };